// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7LpqP","logo":"styles_logo___4Z_Q","actions":"styles_actions__lKoq7"};